export const panoramainputstranslation = {
  en: {
    initialImagePath: "Initial Image Path",
    redirectTo: "Redirect to",
    angle: "Angle",
    remove: "Remove",
    addRedirect: "Add Redirect",
    selectPath: "Select a Path",
  },
  cz: {
    initialImagePath: "Počáteční cesta k obrázku",
    redirectTo: "Přesměrovat na",
    angle: "Úhel",
    remove: "Odstranit",
    addRedirect: "Přidat přesměrování",
    selectPath: "Vyberte cestu",
  },
  sk: {
    initialImagePath: "Počiatočná cesta k obrázku",
    redirectTo: "Presmerovať na",
    angle: "Uhol",
    remove: "Odstrániť",
    addRedirect: "Pridať presmerovanie",
    selectPath: "Vybrať cestu",
  },
  ru: {
    initialImagePath: "Начальный путь к изображению",
    redirectTo: "Перенаправить на",
    angle: "Угол",
    remove: "Удалить",
    addRedirect: "Добавить перенаправление",
    selectPath: "Выберите путь",
  },
  de: {
    initialImagePath: "Anfänglicher Bildpfad",
    redirectTo: "Weiterleiten zu",
    angle: "Winkel",
    remove: "Entfernen",
    addRedirect: "Weiterleitung hinzufügen",
    selectPath: "Wählen Sie einen Pfad",
  },
  hu: {
    initialImagePath: "Kezdő kép útvonal",
    redirectTo: "Átirányítás ide",
    angle: "Szög",
    remove: "Eltávolítás",
    addRedirect: "Átirányítás hozzáadása",
    selectPath: "Válasszon egy utat",
  },
  pl: {
    initialImagePath: "Początkowa ścieżka obrazu",
    redirectTo: "Przekieruj do",
    angle: "Kąt",
    remove: "Usuń",
    addRedirect: "Dodaj przekierowanie",
    selectPath: "Wybierz ścieżkę",
  },
  fr: {
    initialImagePath: "Chemin de l'image initiale",
    redirectTo: "Rediriger vers",
    angle: "Angle",
    remove: "Supprimer",
    addRedirect: "Ajouter une redirection",
    selectPath: "Sélectionner un chemin",
  },
  es: {
    initialImagePath: "Ruta de la imagen inicial",
    redirectTo: "Redirigir a",
    angle: "Ángulo",
    remove: "Eliminar",
    addRedirect: "Agregar redirección",
    selectPath: "Seleccionar un camino",
  },
  nl: {
    initialImagePath: "Initiële afbeeldingspad",
    redirectTo: "Doorverwijzen naar",
    angle: "Hoek",
    remove: "Verwijderen",
    addRedirect: "Doorverwijzing toevoegen",
    selectPath: "Selecteer een pad",
  },
  sv: {
    initialImagePath: "Initial bildsökväg",
    redirectTo: "Omdirigera till",
    angle: "Vinkel",
    remove: "Ta bort",
    addRedirect: "Lägg till omdirigering",
    selectPath: "Välj en väg",
  },
  no: {
    initialImagePath: "Opprinnelig bildebane",
    redirectTo: "Omdiriger til",
    angle: "Vinkel",
    remove: "Fjern",
    addRedirect: "Legg til omdirigering",
    selectPath: "Velg en bane",
  },
  da: {
    initialImagePath: "Initial billedsti",
    redirectTo: "Omdiriger til",
    angle: "Vinkel",
    remove: "Fjern",
    addRedirect: "Tilføj omdirigering",
    selectPath: "Vælg en sti",
  },
  fi: {
    initialImagePath: "Alkuperäinen kuvan polku",
    redirectTo: "Uudelleenohjaa kohteeseen",
    angle: "Kulma",
    remove: "Poista",
    addRedirect: "Lisää uudelleenohjaus",
    selectPath: "Valitse polku",
  },
  ar: {
    initialImagePath: "المسار الأولي للصورة",
    redirectTo: "إعادة التوجيه إلى",
    angle: "الزاوية",
    remove: "إزالة",
    addRedirect: "إضافة إعادة توجيه",
    selectPath: "اختر مسارًا",
  },
};

export default panoramainputstranslation;
